module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn-form', {
    attrs: {
      "title": _vm.title
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function() {
        return [_c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.isNew),
            expression: "!isNew"
          }],
          on: {
            "click": _vm.save
          }
        }, [_vm._v("Сохранить")]), _vm._v(" "), _c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.isNew),
            expression: "!isNew"
          }],
          on: {
            "click": _vm.remove
          }
        }, [_vm._v("Удалить")]), _vm._v(" "), _c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.isNew),
            expression: "isNew"
          }],
          attrs: {
            "disabled": !_vm.valid
          },
          on: {
            "click": _vm.add
          }
        }, [_vm._v("Добавить")]), _vm._v(" "), _c('v-spacer')]
      },
      proxy: true
    }])
  }, [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(!_vm.parentId) ? _c('v-text-field', {
    attrs: {
      "name": "lastName",
      "label": "Фамилия",
      "type": "text",
      "rules": this.lastnameNotNullRule.concat(this.ruleNameRu)
    },
    model: {
      value: (_vm.item.lastName),
      callback: function($$v) {
        _vm.$set(_vm.item, "lastName", $$v)
      },
      expression: "item.lastName"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.parentId) ? _c('v-text-field', {
    attrs: {
      "name": "firstName",
      "label": "Имя",
      "type": "text",
      "rules": _vm.ruleNameRu
    },
    model: {
      value: (_vm.item.firstName),
      callback: function($$v) {
        _vm.$set(_vm.item, "firstName", $$v)
      },
      expression: "item.firstName"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(!_vm.parentId) ? _c('v-text-field', {
    attrs: {
      "name": "middleName",
      "label": "Отчество",
      "type": "text",
      "rules": _vm.ruleNameRu
    },
    model: {
      value: (_vm.item.middleName),
      callback: function($$v) {
        _vm.$set(_vm.item, "middleName", $$v)
      },
      expression: "item.middleName"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.parentId) ? _c('v-text-field', {
    attrs: {
      "name": "innfl",
      "label": "Инн",
      "type": "text",
      "rules": _vm.innflRules
    },
    model: {
      value: (_vm.item.innfl),
      callback: function($$v) {
        _vm.$set(_vm.item, "innfl", $$v)
      },
      expression: "item.innfl"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "name",
      "label": "Название",
      "type": "text"
    },
    model: {
      value: (_vm.item.name),
      callback: function($$v) {
        _vm.$set(_vm.item, "name", $$v)
      },
      expression: "item.name"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-chips-field', {
    attrs: {
      "emptyChip": "Организация",
      "solo": "",
      "flat": "",
      "items": _vm.chipsItems,
      "chipSize": _vm.getIsMobile ? 12 : 25
    },
    on: {
      "remove": _vm.clearInn,
      "click": _vm.selectInn
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "position",
      "label": "Должность",
      "type": "text"
    },
    model: {
      value: (_vm.item.position),
      callback: function($$v) {
        _vm.$set(_vm.item, "position", $$v)
      },
      expression: "item.position"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "email",
      "label": "Эл. почта",
      "type": "text",
      "rules": _vm.emailRules
    },
    model: {
      value: (_vm.item.email),
      callback: function($$v) {
        _vm.$set(_vm.item, "email", $$v)
      },
      expression: "item.email"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "rules": _vm.phoneRules,
      "name": "phone",
      "label": "Тел.",
      "type": "text"
    },
    on: {
      "change": function($event) {
        _vm.item.phone = _vm.formatPhone($event)
      }
    },
    model: {
      value: (_vm.item.phone),
      callback: function($$v) {
        _vm.$set(_vm.item, "phone", $$v)
      },
      expression: "item.phone"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "address",
      "label": "Адрес",
      "type": "text"
    },
    model: {
      value: (_vm.item.address),
      callback: function($$v) {
        _vm.$set(_vm.item, "address", $$v)
      },
      expression: "item.address"
    }
  }), _vm._v(" "), (_vm.parentId) ? _c('v-text-field', {
    attrs: {
      "name": "notes",
      "label": "Заметки",
      "type": "text"
    },
    model: {
      value: (_vm.item.notes),
      callback: function($$v) {
        _vm.$set(_vm.item, "notes", $$v)
      },
      expression: "item.notes"
    }
  }) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-450a135c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/people/ContactForm.vue
// module id = 908
// module chunks = 1